/*
 * One place for the product name, public domain and support address. Everything user-visible
 * reads these values: React code imports the constants, and locale JSON strings use the
 * {{brand}}, {{domain}} and {{supportEmail}} placeholders (the i18n instance supplies them as
 * default interpolation values, see src/i18n/config.ts).
 *
 * Identifiers that must stay stable (storage keys, cookie names, API paths, route paths, i18n
 * keys, embed script attributes) deliberately do not use this module.
 */

const env = import.meta.env;

export const BRAND_NAME: string = env.VITE_BRAND_NAME || 'Scopie';
export const BRAND_DOMAIN: string = env.VITE_BRAND_DOMAIN || 'getscopie.com';
export const SUPPORT_EMAIL: string = env.VITE_SUPPORT_EMAIL || 'info@getscopie.com';

/** Sender address for transactional email (the backend sends it; shown here for reference only). */
export const SENDER_EMAIL = 'hello@getscopie.com';

export const BRAND_TAGLINE = 'Quotes, scheduling and invoices for service businesses';

/** Values every translation can interpolate without the caller passing them. */
export const BRAND_INTERPOLATION = {
  brand: BRAND_NAME,
  domain: BRAND_DOMAIN,
  supportEmail: SUPPORT_EMAIL,
} as const;
